import { all, put, select } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import selectors from "rdx/modules/tickets/selectors";
import messages from "rdx/modules/tickets/messages";

function* deleteProjectMessage(action) {
  const { id } = action.payload;
  const { success, data, error } = yield* makeRequest.delete(`/messages/${id}`, {});

  if (success && data) {
    const list = yield select(selectors.getProjectMessageList);
    yield all([
      put(
        actions.setProjectMessageList({
          list: list.filter((m) => m.id !== id),
        }),
      ),
      put(
        actions.newSuccessEvent({
          message: messages.DELETE_PROJECT_MESSAGE_SUCCESS,
        }),
      ),
    ]);
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_DELETING_PROJECT_MESSAGE,
    });
  }
  return null;
}

export default deleteProjectMessage;
